/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React from 'react';
import Header from '../Header';
import Items from '../Items';
import classes from './Body.module.css';

const Body = props => {
  const {
    menuType,
    goBack,
    outOfStockItems,
    outOfStockSearchList,
    onReloadOutOfStock,
    onSearchOutOfStock,
    includeUnavailable,
    onToggleIncludeUnavailable,
    onUpdateItemStock,
  } = props;

  return (
    <div className={classes.bodyContainer}>
      <Header
        menuType={menuType}
        goBack={goBack}
      />
      <div className={classes.contentWrapper}>
        <Items
          outOfStockItems={outOfStockItems}
          outOfStockSearchList={outOfStockSearchList}
          onReloadOutOfStock={onReloadOutOfStock}
          onSearchOutOfStock={onSearchOutOfStock}
          includeUnavailable={includeUnavailable}
          onToggleIncludeUnavailable={onToggleIncludeUnavailable}
          onUpdateItemStock={onUpdateItemStock}
        />
      </div>
    </div>
  );
};

export default Body;
